
export interface ICompareExchangeValueIncludeBuilder<TBuilder> {
    includeCompareExchangeValue(path: string): TBuilder;
}